/** Approval and college availability govern access, independently of the calendar. */
export function canEnterWorkshop(me) {
  return !!me?.isAdmin || (
    me?.status === 'approved' && !!me?.collegeId && me?.sessionEnabled !== false
  )
}

/** Distinguish any legacy duplicate college records without changing their poll scope. */
export function collegeLabel(college, colleges) {
  const matches = colleges.filter(c => c.name.trim().toLowerCase() === college.name.trim().toLowerCase())
    .sort((a, b) => a.id.localeCompare(b.id))
  return matches.length > 1
    ? `${college.name} · Group ${matches.findIndex(c => c.id === college.id) + 1}`
    : college.name
}
